import { format, addDays, parseISO } from "date-fns";


// Helper function to get today's date in YYYY-MM-DD format
export const getToday = () => {
  return format(new Date(), 'yyyy-MM-dd');
};
// Helper function to get a date 30 days from today in YYYY-MM-DD format
export const get30DaysFromToday = () => {
  return format(addDays(new Date(), 30), 'yyyy-MM-dd');
};
// Helper function to format dates properly for the date input
export const formatDateForInput = (dateString: string | Date | null): string => {
  if (!dateString) return '';
  try {
    // Parse the date and format it to yyyy-MM-dd
    return format(typeof dateString === 'string' ? parseISO(dateString) : dateString, 'yyyy-MM-dd');
  } catch (err) {
    console.error('Error formatting date:', err);
    return '';
  }
};

/**
 * Formats a date into YYYYMMDD format
 * @param date - The date to format
 * @returns A string in YYYYMMDD format
 */
export const formatDateToYYYYMMDD = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}${month}${day}`;
};

export const YYYYMMDDToDate = (dateStr: string): Date => {
  return new Date(
    parseInt(dateStr.substring(0, 4)), // year
    parseInt(dateStr.substring(4, 6)) - 1, // month (0-based)
    parseInt(dateStr.substring(6, 8)) // day
  );
};
